<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog" >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('simple.edit')}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <v-wait for="edit">

                <loading slot="waiting"/>

                <form @submit.prevent="validate_edit">

                    <!-- Name -->
                    <div class="form-group">

                        <label for="name">{{ $t('simple.name') }}</label>

                        <input
                            class="form-control"
                            type="text"
                            id="name"
                            name="name"
                            v-validate="'required|max:15'"
                            v-model="name"
                        >

                        <small v-show="errors.has('name')" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ errors.first('name') }}</small>

                    </div>

                    <!-- Description -->
                    <div class="form-group">

                        <label for="description">{{ $t('simple.desc') }}</label>

                        <input 
                            class="form-control"
                            type="text"
                            id="description"
                            name="description"
                            v-validate="'required|max:50'"
                            v-model="description"
                        >

                        <small v-show="errors.has('description')" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ errors.first('description') }}</small>

                    </div>

                    <!-- Content -->
                    <div class="form-group">

                        <label for="content">{{ $t('simple.content') }}</label>

                        <b-form-textarea
                            :rows="3"
                            :max-rows="6"
                            id="content"
                            name="content"
                            v-validate="'required|max:250'"
                            v-model="content">
                        </b-form-textarea>


                        <small v-show="errors.has('content')" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ errors.first('content') }}</small>

                    </div>

                    <!-- Status -->
                    <div class="form-group">

                        <label for="status">{{ $t('simple.status') }}</label>

                        <b-form-checkbox v-model="status">
                          {{ check_status() }}
                        </b-form-checkbox>

                    </div>

                </form>

            </v-wait>

        </div>

        <div class="modal-footer">

            <b-button @click="$close(false)" variant="secondary">{{ $t('simple.cancel') }}</b-button>

            <b-button @click="validate_edit()" variant="primary">{{ $t('simple.save') }}</b-button>
            
        </div>


        </div>
      </div>
    </div>
</template>
<script>


    export default {

        mounted: function () {
            // Component mounted
            console.log('Announcement Edit Modal mounted');

            // Get data to edit
            this.edit(this.id);
        },
        
        destroyed() {
            // Component destroyed
            console.log('Announcement Edit Modal destroyed.');
        },

        data: function() {
            return  {
                announcements_api: '/api/v1/settings/announcements/',
                name: '',
                description: '',
                content: '',
                status: false,
            }
        },

        methods: {

            edit: async function(id) {

                // Loading start
                this.$wait.start('edit');

                // Get announcement data
                await axios.get(this.announcements_api + id)
                    .then((response) => {

                        // Update modal data
                        this.name = response.data.name;
                        this.description  = response.data.description;
                        this.content = response.data.content;
                        this.status = response.data.status;
                        //console.log(response);

                        // Loading end
                        this.$wait.end('edit');


                    })
                    .catch((error) => {

                        // Loading end
                        this.$wait.end('edit');

                        // Show error
                        Vue.toasted.error(this.$t('simple.error_info'));


                    });

            },

            announcement_edit: async function(){

                // Loading start
                this.$wait.start('edit');

                // Post request
                await axios.put(this.announcements_api  + this.id, {
                    name: this.name,
                    description: this.description,
                    content: this.content,
                    status: this.status,
                  })
                  .then((response) => {

                    // Loading end
                    this.$wait.end('edit');

                    // Show success
                    Vue.toasted.success(this.$t('simple.success_info'));

                    // Close modal
                    this.$close(true);

                  })
                  .catch((error) => {

                    // Loading end
                    this.$wait.end('edit');

                    // Show error
                    Vue.toasted.error(this.$t('simple.error_info'));

                    // Close modal
                    //this.$close(true);

                  });

            },

            check_status: function() {
                if(this.status){
                    return this.$t('default.active');
                } else {
                    return this.$t('default.inactive');
                }
            },

            validate_edit: async function() {
                // validate all fields
                await this.$validator.validateAll().then((result) => {
                    if (result) {
                        // Send it to account edit function
                        this.announcement_edit();
                    }
                });
            },
        },
    }
</script>